import React, { useState } from 'react';
import { ARTICLES } from '../../../data/articles';
import styles from './faq.module.css';

const FAQ_ITEMS = [
  {
    id: 'faq-why-club',
    question: 'Зачем нужен книжный клуб, если можно читать одному?',
    answer:
      'Чтение в одиночку и обсуждение книги — разные интеллектуальные занятия. В первом случае мы исследуем текст со своей точки зрения, а во втором — сталкиваем собственную интерпретацию с чужими. Именно поэтому знакомое произведение может оказаться совсем не таким знакомым. Клуб нужен, чтобы вместе искать смыслы: не для оценки пересказа, а для исследования книги.',
  },
  {
    id: 'faq-meeting',
    question: 'Что делают в книжном клубе на встрече?',
    answer:
      'Встреча — совместный разбор: участники задают вопросы, предлагают версии, ищут связи и проверяют интерпретации по тексту. Книгу выбирает ведущая, а обсуждение строится вокруг вопросов, а не пересказа сюжета.',
  },
  {
    id: 'faq-discussion',
    question: 'Как обсуждать книгу, чтобы понять её глубже?',
    answer:
      'Не ограничивайтесь «понравилось — не понравилось». Полезно спрашивать о сюжете и устройстве истории, о персонажах, о мире и теме произведения, об авторе и читателе. Вопрос «что хотел сказать автор?» не имеет одного короткого ответа — его можно исследовать вместе.',
  },
  {
    id: 'faq-unfinished',
    question: 'Можно ли прийти, если не дочитал книгу?',
    answer:
      'Можно. Дочитывание не превращается в пропускной билет: к обсуждению можно присоединиться и с непрочитанными страницами. Обсуждайте то, что заметили, слушайте версии других и уточняйте собственные предположения.',
  },
  {
    id: 'faq-education',
    question: 'Нужно ли иметь филологическое образование, чтобы участвовать?',
    answer:
      'Нет. Встречи рассчитаны не на проверку терминов и не на соревнование в эрудиции — важнее любопытство, умение слушать и готовность объяснять, почему ты видишь текст именно так.',
  },
];

export const SectionFAQ = () => {
  const [openId, setOpenId] = useState(FAQ_ITEMS[0].id);

  const toggleItem = (id) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section className={styles.sectionFaqContainer} id="faq">
      <h2 className={styles.sectionFaqTitle}>FAQ</h2>
      <p className={styles.sectionFaqSubtitle}>
        Ответы на частые вопросы о книжном клубе: зачем он нужен, как проходит обсуждение и можно ли прийти, не дочитав книгу.
      </p>

      <div className={styles.sectionFaqList}>
        {FAQ_ITEMS.map((item) => {
          const isOpen = openId === item.id;

          return (
            <div
              key={item.id}
              className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ''}`}
            >
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />

              <button
                type="button"
                className={styles.faqQuestion}
                onClick={() => toggleItem(item.id)}
                aria-expanded={isOpen}
              >
                <span className={styles.faqQuestionText}>{item.question}</span>
                <span className={styles.faqChevron} aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
                  </svg>
                </span>
              </button>

              {isOpen && (
                <div className={styles.faqAnswer}>
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className={styles.faqArticles}>
        <h3 className={styles.faqArticlesTitle}>Статьи по теме</h3>
        <div className={styles.faqArticlesGrid}>
          {ARTICLES.map((article) => (
            <a
              key={article.slug}
              href={`/blog/${article.slug}`}
              className={styles.faqArticleCard}
            >
              <span className={styles.faqArticleTitle}>{article.h1}</span>
              <span className={styles.faqArticleText}>{article.description}</span>
              <span className={styles.faqArticleArrow} aria-hidden="true">→</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
